import { Button } from "../../components/Button"
import { EvidenceBox, MessageBox } from "../../components/MessageBox"
import "./styles.scss"
import { Warning } from "../../components/Warning"
import HeaderBack from "../../components/HeaderBack"
import { InputFileWithPreview } from "../../components/FileInput"
import { isMobile } from "react-device-detect"
import CameraGallery from "../../container/CameraGalleryContainer"

export const InfoTitle = ({ info, counter, children }) => {
  return (
    <div className="info-title">
      <h2>
        {info} {`${counter?.length > 0 ? `(${counter?.length})` : ``}`}
      </h2>
      <div className="info-content">{children}</div>
    </div>
  )
}

export const AssistanceLinkMessageScreen = ({
  formQuestionMessage,
  goToLastStep,
  answers,
  handleCloseTab,
  removePinnedMessage,
  pinnedMessages,
  onChangeFile,
  loadingProcessImage,
  onChangeQuestionsInfo = () => { },
  uploadedEvidences,
  evidences = [],
  pinnedMessagesQuestions,
  evidenceId,
  handleRemoveEvidence,
  handleUploadPhotos
}) => {

  return (
    <div className="link_message__container">
      <HeaderBack title="Adicionar Evidência" handleGoBack={handleCloseTab} />
      <div className="link_message_subheader">
        {pinnedMessages?.length > 0 ? (
          <></>
        ) : (
          <Warning label={isMobile ? `Para vincular uma evidência ao atendimento, clique no ícone do chat para adicionar mensagens o selecione um arquivo.` : `Para vincular uma evidência diretamente do chat, clique no ícone "+" ao lado de cada mensagem desejada. Para evidências externas, selecione arquivo clicando abaixo:`} />
        )}
        <div className="questions-button-save">
          <Button
            color="primary"
            label="Salvar Evidências"
            isDisabled={
              loadingProcessImage && evidenceId
                ? loadingProcessImage === evidenceId
                : false
            }
            handleClick={handleCloseTab}
          />
        </div>
      </div>
      <div className="link_message_content">
        <div className="link_assistance_input">
          <h2>Anexar Novos Arquivos</h2>
          <div className="upload-button-evidence" style={{ display: "flex", gap: "12px", flexDirection: "column" }}>
            <InputFileWithPreview
              name="files"
              accept="image/png,image/jpeg,image/jpg,video/mp4,.doc,docx,.xls,xlsx,.pdf,.ppt,.pptx"
              handleChangeFile={(e) => onChangeFile(e, formQuestionMessage?.name)}
              clearPreview={uploadedEvidences?.length > 0}
              loadingProcessImage={
                loadingProcessImage && formQuestionMessage
                  ? loadingProcessImage === formQuestionMessage?.name
                  : false
              }
              isMultiple={true}
            />
            <CameraGallery
              questionId={evidenceId}
              handleUploadPhotos={handleUploadPhotos}
            />
          </div>
        </div>
        <div className="evidences-messages-container">
          {answers[`${formQuestionMessage?.name}-evidence`]?.length > 0 && (
            <>
              <InfoTitle info="Arquivos" counter={answers[`${formQuestionMessage?.name}-evidence`]} />
              <div className="pinned-messages-container">
                <EvidenceBox hasActions={true} handleRemoveEvidence={handleRemoveEvidence} questionId={evidenceId || formQuestionMessage?.name} evidences={answers[`${formQuestionMessage?.name}-evidence`]} />
              </div>
            </>
          )}
          <div>
            {Array.isArray(pinnedMessages) && pinnedMessages.filter(Boolean).length > 0 && (
              <>
                <InfoTitle info="Mensagens" counter={pinnedMessages} />
                <div className="pinned-messages-container">
                  {pinnedMessages.map((message) => (
                    <MessageBox
                      message={message}
                      hasActions
                      removePinnedMessage={() => removePinnedMessage(message?.id, evidenceId)}
                    />
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
